/**
 * Created by RUSS_ on 09.05.2018
 */
import { ANALYTICS_IDS, OPTIN_URLS, OPTOUT_URLS } from "../const/constants";

/**
 * This is main function for opt in/out of a cookie. This should implement all the variants of cookies which should be opted in/out.
 * @param cookie
 * @returns {Promise<any>}
 */
export function optInOut(cookie) {
  return new Promise((resolve, reject) => {
    if (cookie.domains.indexOf("salesforce.com") > -1) {
      // // SALESFORCE OPT IN / OUT works by a http request
      // if (cookie.accepted) {
      //   return httpRequest(OPTOUT_URLS.SALESFORCE, cookie).then(() => {
      //     resolve();
      //   });
      // } else {
      //   return httpRequest(OPTIN_URLS.SALESFORCE, cookie).then(() => {
      resolve();
      // });
      // }
    } else if (cookie.id === "google_analytics") {
      // GOOGLE ANALYTICS OPT IN / OUT
      // see https://developers.google.com/analytics/devguides/collection/analyticsjs/user-opt-out
      for (let i = 0; i < ANALYTICS_IDS.length; i++) {
        window["ga-disable-" + ANALYTICS_IDS[i]] = !cookie.accepted;
        if (typeof ga !== "undefined") {
          ga("create", ANALYTICS_IDS[i], "auto", { storeGac: cookie.accepted });
          console.log(
            "set cookie acceptance on google analytics " +
              ANALYTICS_IDS[i] +
              " to " +
              cookie.accepted
          );
        }
      }
      resolve();
    } else {
      resolve();
    }
  });
}

function httpRequest(url, cookie) {
  return new Promise((resolve, reject) => {
    $.ajax({
      dataType: "json",
      url: url,
      type: "GET",
      success: function(data) {
        console.log(
          "Successfully " +
            (cookie.accepted ? "opt in" : "opt out") +
            " " +
            cookie.domains.toString()
        );
        resolve(data);
      },
      error: function(jqXHR) {
        console.error(
          "Cannot " +
            (cookie.accepted ? "opt in" : "opt out") +
            " " +
            cookie.domains.toString()
        );
        resolve(url);
      }
    });
  });
}



// WEBPACK FOOTER //
// ./src-cookie-manager/managers/opt-in-out-manager.js